import PropTypes from 'prop-types'
import classNames from 'classnames'

import Link from 'components/Link'

import s from './WordpressLink.module.css'

function WordpressLink({
  children = null,
  className = '',
  isExternalLink = false,
  url = null,
  label = null,
  link = null,
  ...props
}) {
  if (isExternalLink)
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames(s.container, className)}
        dangerouslySetInnerHTML={{ __html: label }}
        {...props}
      >
        {children}
      </a>
    )

  const linkedTo = link?.nodes?.[0] ?? link

  return (
    <Link
      type={linkedTo?.__typename}
      href={linkedTo?.uri || linkedTo?.slug}
      className={classNames(s.container, className)}
      {...props}
    >
      {children || label}
    </Link>
  )
}

WordpressLink.propTypes = {
  children: PropTypes.node,
  url: PropTypes.string,
  isExternalLink: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  link: PropTypes.object,
}

export default WordpressLink
